export default "__VITE_ASSET__ps3EH3kE__"